import React, { ReactNode } from 'react'

import {
  PlanFeaturesRowTitle,
  PlanFeaturesRowStyled,
  PlanFeaturesRowCell,
  PlanFeaturesRowTitleText,
} from 'Features/pricing/components/PlanFeaturesTable/PlanFeaturesRow/PlanFeaturesRow.styled'
import { theme, Tooltip } from '@clickcease/cc-client-components-lib'
import { CSS } from '@stitches/react'
import { isMobile } from 'react-device-detect'

type PlanFeaturesRowProps = {
  title: string
  tooltip: string
  cells: Array<ReactNode | string>
  featureNameCss?: CSS
  cellCss?: CSS
}

export const PlanFeaturesRow = ({
  title,
  tooltip,
  cells,
  featureNameCss,
  cellCss,
}: PlanFeaturesRowProps) => {
  const renderCells = () => {
    return cells.map((cell, index) => {
      return (
        <PlanFeaturesRowCell css={cellCss} key={index}>
          {cell}
        </PlanFeaturesRowCell>
      )
    })
  }

  return (
    <PlanFeaturesRowStyled>
      <PlanFeaturesRowTitle>
        <PlanFeaturesRowTitleText css={featureNameCss}>{title}</PlanFeaturesRowTitleText>
        {!isMobile && (
          <Tooltip
            tooltiptContent={tooltip}
            trigerStyle={{
              style: {
                color: theme.colors.gray.value,
              },
              width: '16px',
            }}
          />
        )}
      </PlanFeaturesRowTitle>
      {renderCells()}
    </PlanFeaturesRowStyled>
  )
}
